// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"b0639bdf","453":"b649a39b"}[chunkId] + ".chunk.js";
};